import Vue from "vue";
import VuePortal from "portal-vue";

export function install(vue: typeof Vue): void {
  vue.use(VuePortal);
}
